/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'

import { TrailersApi } from '../useCreateTrailer/api'

const useTrailers = () => {
  const [isAddTrailerModalOpen, setIsAddTrailerModalOpen] = useState(false)
  const [isEditTrailerModalOpen, setIsEditTrailerModalOpen] = useState(false)
  const [isViewTrailerModalOpen, setIsViewTrailerModalOpen] = useState(false)
  const [isAddDriverUnitModal, setIsAddDriverUnitModal] = useState(false)
  const [isAddTrailerModal, setIsAddTrailerModal] = useState(false)

  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const onAddTruckSuccess = () => {
    notification.success({
      message: t('Trailer added successfully'),
    })
    setIsAddTrailerModalOpen(false)
    setIsAddDriverUnitModal(false)
    setIsAddTrailerModal(false)
    queryClient.invalidateQueries(QUERY_KEYS.TRAILER)
  }

  const onAddTruckError = () => {
    notification.error({
      message: t('Error adding truck'),
    })
  }

  const { mutate: addTrailer, isLoading: addTrailerLoading } = useMutation(
    TrailersApi.createTrailer,
    {
      onSuccess: onAddTruckSuccess,
      onError: onAddTruckError,
    },
  )

  const openEditTrailerModal = () => {
    setIsEditTrailerModalOpen(true)
  }

  const closeEditTrailerModal = () => {
    setIsEditTrailerModalOpen(false)
  }

  return {
    addTrailer,
    addTrailerLoading,
    isAddTrailerModalOpen,
    setIsAddTrailerModalOpen,
    isEditTrailerModalOpen,
    setIsEditTrailerModalOpen,
    openEditTrailerModal,
    closeEditTrailerModal,
    isViewTrailerModalOpen,
    setIsViewTrailerModalOpen,
    isAddDriverUnitModal,
    setIsAddDriverUnitModal,
    isAddTrailerModal,
    setIsAddTrailerModal,
  }
}

export { useTrailers }
